import { Document } from '@/model/document2/document';
import { Design } from '@/model/document2/page/surface/design/design';
import { D3TextLayer } from '@/model/document2/page/surface/design/layer/d3TextLayer';
import { NumberLayer } from '@/model/document2/page/surface/design/layer/numberLayer';
import { SimpleTextLayer } from '@/model/document2/page/surface/design/layer/simpleTextLayer';
import { DebugHelper } from './debugHelper';

// ドキュメントヘルパークラス
export class DocumentHelper
{
    // 用紙情報のテキストを取得する
    public static getPaperInfoText(document : Document)
    {
        // 形式は 
        // 品番:3123444 フォーマット番号:F150A4ー1 A4サイズ
        var paperCode = document.paperCode;
        var formatCode = document.paperFormatCode;
        var productName = document.productName;

        var text = "品番:" + paperCode;
        if(formatCode != "")
        {
            text += " " + "フォーマット番号:" + formatCode;
        }
        if(productName != null)
        {
            text += " " + productName;
        }

        return text;
    }

    // designのNumberLayerの参照先をorgDesignに合わせ、documentからNumberCoreLayerを削除する
    public static unityNumberLayersLink(design : Design, orgDesign : Design)
    {
        var designLayers = design.getAllLayers(false);
        var orgDesignLayers = orgDesign.getAllLayers(false);
        var layersLength = designLayers.length;

        for(var i = 0; i < layersLength; ++i)
        {
            if(i < designLayers.length && i < orgDesignLayers.length)
            {
                var layer = designLayers[i];
                var orgLayer = orgDesignLayers[i];
                if(layer instanceof NumberLayer && orgLayer instanceof NumberLayer)
                {
                    // Document取得
                    var doc = layer.document;
                    if(doc == null) continue;
                    // linkId取得
                    var linkId = orgLayer.linkId;
                    var newLinkId = layer.linkId;
                    // linkIdを揃える
                    layer.linkId = linkId;
                    // linkIdを元にNumberCoreLayerを削除
                    var removeIndex = -1;
                    for(var j = 0; j < doc.numberLayers.length; ++j)
                    {
                        if(doc.numberLayers[j].linkId == newLinkId)
                        {
                            removeIndex = j;
                            break;
                        }
                    }
                    // 削除
                    if(removeIndex >= 0) doc.numberLayers.splice(removeIndex, 1);
                }
            }
        }
    }

    // ドキュメントに3Dテキストレイヤーが含まれているか？
    public static contains3dTextLayers(doc : Document) {
        let ret = false;
        for(let pageIndex = 0; pageIndex < doc.pageList.length; ++pageIndex) {
            let page = doc.pageList[pageIndex];
            for(let surfaceIndex = 0; surfaceIndex < page.surfaces.length; ++ surfaceIndex) {
                let surface = page.surfaces[surfaceIndex];
                for(let designIndex = 0; designIndex < page.designMaxNumber; ++designIndex) {
                    let design = surface.getDesign(designIndex);
                    if(design == null) continue;
                    let layers = design.getAllLayers();
                    for(let layerIndex = 0; layerIndex < layers.length; ++layerIndex) {
                        let layer = layers[layerIndex];
                        if(layer.layerType == "d3Text") {
                            ret = true;
                            break;
                        }
                    }
                    if(ret)break;
                }
                if(ret)break;
            }
            if(ret)break;
        }
        return ret;
    }

    // ドキュメントに含まれる3Dテキストレイヤーを通常文字に変換する
    public static convert3dTextLayersToSimpleTextLayers(doc : Document) {
        for(let pageIndex = 0; pageIndex < doc.pageList.length; ++pageIndex) {
            let page = doc.pageList[pageIndex];
            for(let surfaceIndex = 0; surfaceIndex < page.surfaces.length; ++ surfaceIndex) {
                let surface = page.surfaces[surfaceIndex];
                for(let designIndex = 0; designIndex < page.designMaxNumber; ++designIndex) {
                    let design = surface.getDesign(designIndex);
                    if(design == null) continue;
                    let layers = design.getAllLayers();
                    for(let layerIndex = 0; layerIndex < layers.length; ++layerIndex) {
                        let layer = layers[layerIndex];
                        if(layer.layerType == "d3Text") {
                            DebugHelper.trace("convert d3text -> simpletext: " + layer.name);
                            let orgLayer = layer as D3TextLayer;
                            let parentLayer = design.getParentLayer(layer);
                            if(parentLayer == null) continue;
                            let originalIdx = parentLayer.getLayerIndex(layer);
                            if(originalIdx < 0) continue;
                            parentLayer.removeLayerByIndex(originalIdx);
                            let convertedLayer = SimpleTextLayer.create(orgLayer.text, orgLayer.x, orgLayer.y, orgLayer.width, orgLayer.height);
                            convertedLayer.id = orgLayer.id;
                            convertedLayer.name = orgLayer.name;
                            convertedLayer.autoSize = true;
                            convertedLayer.autoFontSize = 0;
                            convertedLayer.baseTextInfo.fontId = orgLayer.fontId;
                            convertedLayer.baseTextInfo.textColor = orgLayer.textColor;
                            parentLayer.insertLayer(originalIdx, convertedLayer);
                        }
                    }
                }
            }
        }
    }
}